import PageDefault from "components/PageDefault";
import { useTranslation } from "react-i18next";

export default function Reports(){
  const { t } = useTranslation()
  return (
    <PageDefault title={t('title:reports')}>
      <PageDefault.Title>{t('title:reports')}</PageDefault.Title>
      <PageDefault.Content>
        
      </PageDefault.Content>
    </PageDefault>
  );
}